"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createSignal = exports.INITIAL_SIGNAL = void 0;
exports["default"] = comboBoxBase;
exports.signaled = exports.isTabbingOutOfElement = exports.isControlled = exports.getComponentFocusObservable = exports.getComponentBlurObservable = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireDefault(require("react"));
var _compose = _interopRequireDefault(require("lodash/fp/compose"));
var _eq = _interopRequireDefault(require("lodash/fp/eq"));
var _defer = _interopRequireDefault(require("lodash/fp/defer"));
var _first = _interopRequireDefault(require("lodash/fp/first"));
var _last = _interopRequireDefault(require("lodash/fp/last"));
var _includes = _interopRequireDefault(require("lodash/fp/includes"));
var _isNil = _interopRequireDefault(require("lodash/fp/isNil"));
var _isFunction = _interopRequireDefault(require("lodash/fp/isFunction"));
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _eventHandler = require("@active/react-utils/eventHandler");
var _dom = require("@active/react-utils/dom");
var _scopedFocus = _interopRequireDefault(require("@active/react-utils/dom/scopedFocus"));
var _constants = require("../constants");
var _focusUtils = require("./focusUtils");
var INITIAL_SIGNAL = exports.INITIAL_SIGNAL = 0;
var CLOSELY_FOLLOWED_ACTION_PERIOD = 50;
var COMBOBOX_FOCUS = 'combobox:focus';
var COMBOBOX_BLUR = 'combobox:blur';
var LISTBOX_CLICK = 'listbox:click';
var LISTBOX_FOCUS = 'listbox:focus';
var LISTBOX_COLLAPSE = 'listbox:collapse';
var createSignal = exports.createSignal = Math.random.bind(Math);
var signaled = exports.signaled = function signaled(signal) {
  return signal > INITIAL_SIGNAL;
};
var isTabbingOutOfElement = exports.isTabbingOutOfElement = function isTabbingOutOfElement(e, element) {
  return e.key === _constants.KEY_VALUES.TAB && (e.shiftKey && (0, _focusUtils.firstFocusableOf)(element) === e.target || !e.shiftKey && (0, _focusUtils.lastFocusableOf)(element) === e.target);
};
var getComponentBlurObservable = exports.getComponentBlurObservable = function getComponentBlurObservable(params) {
  var comboBox = params.comboBox,
    listBox = params.listBox;
  var comboBoxBlur$ = (0, _rxjs.fromEvent)(comboBox, 'blur').pipe((0, _operators.map)(function (e) {
    return [COMBOBOX_BLUR, e];
  }));
  var listBoxClick$ = (0, _rxjs.fromEvent)(listBox, 'click').pipe((0, _operators.map)(function (e) {
    return [LISTBOX_CLICK, e];
  }));
  var listBoxFocus$ = (0, _rxjs.fromEvent)(listBox, 'focus', {
    capture: true
  }).pipe((0, _operators.map)(function (e) {
    return [LISTBOX_FOCUS, e];
  }));
  return comboBoxBlur$.pipe((0, _operators.mergeWith)(listBoxClick$, listBoxFocus$)).pipe((0, _operators.debounceTime)(CLOSELY_FOLLOWED_ACTION_PERIOD)).pipe((0, _operators.filter)((0, _compose["default"])((0, _eq["default"])(COMBOBOX_BLUR), _first["default"]))).pipe((0, _operators.map)(_last["default"]));
};
var getComponentFocusObservable = exports.getComponentFocusObservable = function getComponentFocusObservable(params) {
  var comboBoxFocus$ = params.comboBoxFocus$,
    listBoxCollapse$ = params.listBoxCollapse$;
  return comboBoxFocus$.pipe((0, _operators.map)(function (e) {
    return [COMBOBOX_FOCUS, e];
  })).pipe((0, _operators.mergeWith)(listBoxCollapse$.pipe((0, _operators.map)(function () {
    return [LISTBOX_COLLAPSE];
  })))).pipe((0, _operators.throttleTime)(CLOSELY_FOLLOWED_ACTION_PERIOD)).pipe((0, _operators.filter)((0, _compose["default"])((0, _eq["default"])(COMBOBOX_FOCUS), _first["default"]))).pipe((0, _operators.map)(_last["default"]));
};
var isControlled = exports.isControlled = function isControlled(userExpanded, onUserExpandedChange) {
  return !(0, _isNil["default"])(userExpanded) && (0, _isFunction["default"])(onUserExpandedChange);
};
function comboBoxBase(wrappedFunction) {
  return function (_ref) {
    var comboBoxRef = _ref.comboBoxRef,
      _ref$defaultExpanded = _ref.defaultExpanded,
      defaultExpanded = _ref$defaultExpanded === void 0 ? false : _ref$defaultExpanded,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      userExpanded = _ref.expanded,
      onExpandedChange = _ref.onExpandedChange,
      listBoxRef = _ref.listBoxRef,
      _ref$enableListBoxLoo = _ref.enableListBoxLoopTab,
      enableListBoxLoopTab = _ref$enableListBoxLoo === void 0 ? false : _ref$enableListBoxLoo,
      onBlur = _ref.onBlur,
      onFocus = _ref.onFocus,
      triggerExceptions = _ref.triggerExceptions;
    var _React$useState = _react["default"].useState({
        expanded: userExpanded || defaultExpanded
      }),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      _React$useState2$ = _React$useState2[0],
      expanded = _React$useState2$.expanded,
      byMouse = _React$useState2$.byMouse,
      setExpanded = _React$useState2[1];
    var _React$useState3 = _react["default"].useState(INITIAL_SIGNAL),
      _React$useState4 = (0, _slicedToArray2["default"])(_React$useState3, 2),
      focusComboBoxSignal = _React$useState4[0],
      signalFocusComboBox = _React$useState4[1];
    var _React$useState5 = _react["default"].useState(INITIAL_SIGNAL),
      _React$useState6 = (0, _slicedToArray2["default"])(_React$useState5, 2),
      focusListBoxSignal = _React$useState6[0],
      signalFocusListBox = _React$useState6[1];
    var listBoxCollapseSubject = _react["default"].useRef(new _rxjs.Subject());
    var loopInListBox = _react["default"].useCallback(function (e, element) {
      var direction = e.shiftKey ? 'previous' : 'next';
      if (e.key === _constants.KEY_VALUES.TAB) {
        e.stopPropagation();
        e.preventDefault();
        (0, _scopedFocus["default"])(element, {
          direction: direction,
          circular: true
        });
      }
    }, []);
    var changeExpandedStatus = _react["default"].useCallback(function (value, byMouseValue) {
      if (isControlled(userExpanded, onExpandedChange)) {
        onExpandedChange === null || onExpandedChange === void 0 || onExpandedChange(value);
      } else {
        byMouseValue ? setExpanded({
          expanded: value,
          byMouse: byMouseValue
        }) : setExpanded({
          expanded: value
        });
      }
    }, [setExpanded, userExpanded, onExpandedChange]);
    var expand = _react["default"].useCallback(function () {
      if (!disabled) {
        changeExpandedStatus(true);
      }
    }, [disabled, changeExpandedStatus]);
    var collapse = _react["default"].useCallback(function () {
      changeExpandedStatus(false);
      signalFocusComboBox(createSignal());
      listBoxCollapseSubject.current.next();
    }, [signalFocusComboBox, changeExpandedStatus]);
    var handleComboBoxClick = _react["default"].useCallback(function (e) {
      if (!disabled && !(0, _includes["default"])(e.target)(triggerExceptions)) {
        var byMouseValue = true;
        changeExpandedStatus(true, byMouseValue);
      }
    }, [disabled, triggerExceptions, changeExpandedStatus]);
    var handleListBoxKeyDown = _react["default"].useCallback(function (e) {
      if (enableListBoxLoopTab) {
        loopInListBox(e, listBoxRef.current);
      } else if (isTabbingOutOfElement(e, listBoxRef.current)) {
        e.preventDefault();
        collapse();
      }
    }, [collapse, listBoxRef, enableListBoxLoopTab, loopInListBox]);
    var shouldReturnFocusToComboBox = _react["default"].useCallback(function () {
      var activeEl = (0, _dom.getActiveElement)();
      return !((0, _dom.hasActiveElInDOM)() && activeEl.tabIndex > -1);
    }, [_dom.getActiveElement, _dom.hasActiveElInDOM]);
    _react["default"].useEffect(function syncUserExpandedStatus() {
      return isControlled(userExpanded, onExpandedChange) && userExpanded !== expanded ? setExpanded({
        expanded: userExpanded
      }) : undefined;
    }, [expanded, setExpanded, userExpanded, onExpandedChange]);
    _react["default"].useEffect(function handleListBoxClickEscape() {
      return expanded ? (0, _eventHandler.listenPointerdownEscape)(collapse, [listBoxRef, comboBoxRef]) : undefined;
    }, [collapse, expanded, listBoxRef, comboBoxRef]);
    _react["default"].useEffect(function handleListBoxKeyboardEscape() {
      return expanded ? (0, _eventHandler.listenKeyboardEscape)(function (e) {
        collapse();
        e.stopPropagation();
      }, [listBoxRef]) : undefined;
    }, [collapse, expanded, listBoxRef]);
    _react["default"].useEffect(function handleComboboxBoxKeyboardEscape() {
      return expanded ? (0, _eventHandler.listenKeyboardEscape)(function () {
        collapse();
      }, [comboBoxRef]) : undefined;
    }, [collapse, expanded, comboBoxRef]);
    _react["default"].useEffect(function handleFocusComboBoxSignal() {
      if (signaled(focusComboBoxSignal) && shouldReturnFocusToComboBox()) {
        (0, _defer["default"])(function () {
          (0, _focusUtils.focus)(comboBoxRef.current);
        });
      }
    }, [focusComboBoxSignal, comboBoxRef, shouldReturnFocusToComboBox]);
    _react["default"].useEffect(function handleComponentFocus() {
      var comboBox = comboBoxRef === null || comboBoxRef === void 0 ? void 0 : comboBoxRef.current;
      if (!comboBox) {
        return undefined;
      }
      var comboBoxFocus$ = (0, _rxjs.fromEvent)(comboBox, 'focus');
      var componentFocus$ = getComponentFocusObservable({
        comboBoxFocus$: comboBoxFocus$,
        listBoxCollapse$: listBoxCollapseSubject.current
      }).subscribe(function (event) {
        onFocus === null || onFocus === void 0 || onFocus(event);
      });
      return function () {
        componentFocus$.unsubscribe();
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [comboBoxRef, comboBoxRef === null || comboBoxRef === void 0 ? void 0 : comboBoxRef.current, onFocus]);
    _react["default"].useEffect(function handleComponentBlur() {
      var listBox = listBoxRef === null || listBoxRef === void 0 ? void 0 : listBoxRef.current;
      var comboBox = comboBoxRef === null || comboBoxRef === void 0 ? void 0 : comboBoxRef.current;
      if (!comboBox) {
        return undefined;
      }
      var observer;
      if (!listBox) {
        observer = (0, _rxjs.fromEvent)(comboBox, 'blur').pipe((0, _operators.debounceTime)(CLOSELY_FOLLOWED_ACTION_PERIOD));
      } else {
        observer = getComponentBlurObservable({
          comboBox: comboBox,
          listBox: listBox
        });
      }
      var componentBlur$ = observer.subscribe(function (event) {
        changeExpandedStatus(false);
        onBlur === null || onBlur === void 0 || onBlur(event);
      });
      return function () {
        componentBlur$.unsubscribe();
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [listBoxRef, comboBoxRef, listBoxRef === null || listBoxRef === void 0 ? void 0 : listBoxRef.current, comboBoxRef === null || comboBoxRef === void 0 ? void 0 : comboBoxRef.current, expanded, onBlur, changeExpandedStatus]);
    _react["default"].useEffect(function addEventListeners() {
      var comboBox = comboBoxRef === null || comboBoxRef === void 0 ? void 0 : comboBoxRef.current;
      var listBox = listBoxRef === null || listBoxRef === void 0 ? void 0 : listBoxRef.current;
      comboBox === null || comboBox === void 0 || comboBox.addEventListener('click', handleComboBoxClick);
      listBox === null || listBox === void 0 || listBox.addEventListener('keydown', handleListBoxKeyDown);
      return function () {
        comboBox === null || comboBox === void 0 || comboBox.removeEventListener('click', handleComboBoxClick);
        listBox === null || listBox === void 0 || listBox.removeEventListener('keydown', handleListBoxKeyDown);
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [comboBoxRef, comboBoxRef.current, handleComboBoxClick, handleListBoxKeyDown, listBoxRef, listBoxRef === null || listBoxRef === void 0 ? void 0 : listBoxRef.current]);
    wrappedFunction === null || wrappedFunction === void 0 || wrappedFunction({
      byMouse: byMouse,
      disabled: disabled,
      expanded: expanded,
      setExpanded: setExpanded,
      changeExpandedStatus: changeExpandedStatus,
      focusComboBoxSignal: focusComboBoxSignal,
      signalFocusComboBox: signalFocusComboBox,
      comboBoxRef: comboBoxRef,
      listBoxRef: listBoxRef,
      listBoxCollapseSubject: listBoxCollapseSubject,
      focusListBoxSignal: focusListBoxSignal,
      signalFocusListBox: signalFocusListBox
    });
    return {
      expanded: expanded,
      collapse: collapse,
      expand: expand
    };
  };
}